<template>
<div class="ibox float-e-margins">
  <div class="row m-b-lg m-t-lg" v-if="check">
    <div class="col-md-2">
      <h3><a :href="'https://' + check.domain" target="_blank">{{ check.domain }}</a></h3>
    </div>
    <div class="col-md-3">
      <table class="table small m-b-xs">
        <tr>
          <td colspan="2">
          </td>
        </tr>
        <tbody>
        <tr>
          <td>Status</td>
          <td><b>{{ check.status }}</b></td>
        </tr>
        <tr>
          <td>Start Time</td>
          <td>{{ $moment(check.startTime.date).format('DD.MM.YYYY HH:mm') }}</td>
        </tr>
        <tr v-if="check.results">
          <td>Pages Found</td>
          <td>{{ check.results.length }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div class="row">
        <div class="table-responsive col-lg-12">
          <table class="table table-striped table-bordered table-hover dataTables-example">
            <thead>
            <tr>
              <th class="col-lg-2">
                Url
              </th>
            </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Check',
  data () {
    return {
      id: null,
      check: null
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.loadCheck(this.id)
  },
  methods: {
    loadCheck (id) {
      axios.get('/toolbox/seo/index-checker/index-check/' + id)
        .then(r => {
          this.check = r.data
        })
        .catch(e => {
          this.$toastr.error(e, 'Bad shit sherlock')
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Std/IndexChecker/Check.vue